import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import PlaybackWindow from './PlaybackWindow';
import { playbackActions } from 'store/playbackSlice/playbackSlice';
import { selectPlaybackIsOpen, selectPlaybackUrl, selectPlaybackIsLoading, selectPlaybackCameraName } from 'store/playbackSlice/playbackSelectors';

const PlaybackWindowPortal = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(selectPlaybackIsOpen);
    const playbackUrl = useSelector(selectPlaybackUrl);
    const isLoading = useSelector(selectPlaybackIsLoading);
    const cameraName = useSelector(selectPlaybackCameraName);

    const handleClose = useCallback(() => {
        dispatch(playbackActions.closePlayback());
    }, [dispatch]);

    const portalTarget =
        document.getElementById('playback-window-root') ||
        (() => {
            const el = document.createElement('div');
            el.id = 'playback-window-root';
            document.body.appendChild(el);
            return el;
        })();

    return ReactDOM.createPortal(
        <PlaybackWindow isOpen={isOpen} onClose={handleClose} playbackUrl={playbackUrl} isLoading={isLoading} cameraName={cameraName} />,
        portalTarget
    );
};

export default PlaybackWindowPortal;
